import React, { useState } from 'react';
import './InputBox.css';
import './large-compo-box-container.css';
<link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
/>

const LargeInputBoxWithIcon = ({
  label,
  defaultValue = '',
  onChange,
  type = 'text',
  validators = [],
  name,
  error,
  isRequired = false
}) => {
  const [value, setValue] = useState(defaultValue);
  const [errors, setErrors] = useState([]);

  const validatorArray = Array.isArray(validators) 
    ? validators 
    : (validators ? [validators] : []);

  const effectiveValidators = isRequired 
    ? [
      ...(typeof validatorArray === 'function' ? [validatorArray] : validatorArray),
      (val) => val !== null && val !== undefined && val !== '' || "This field is required"
    ]
    : validatorArray;

  const validateInput = (inputValue) => {
    const newErrors = effectiveValidators
      .map((validator) => {
        if (typeof validator === 'function') {
          const result = validator(inputValue);
          return result === true ? null : result;
        }
        return null;
      })
      .filter((error) => typeof error === 'string');

    return newErrors;
  };

  const handleInputChange = (event) => {
    const newValue = event.target.value;
    
    const newErrors = validateInput(newValue);
    
    setValue(newValue);
    setErrors(newErrors);

    if (onChange) {
      onChange(event);
    }
  };

  const displayErrors = error ? [error] : errors;

  return (
    <div className='large-compo-box-container small-icon-select-input-container'>
      <svg className='icon-input' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M5.92074 1.43777C4.61756 1.85061 3.46681 2.64211 2.61514 3.71141C1.76347 4.7807 1.24946 6.07935 1.1386 7.44186H4.47256C4.49712 6.62623 4.57302 5.82251 4.69953 5.06047C4.85358 4.12726 5.08279 3.26698 5.37674 2.53023C5.52555 2.15077 5.7076 1.78519 5.92074 1.43777ZM8 0C6.94943 -1.56548e-08 5.90914 0.206926 4.93853 0.608964C3.96793 1.011 3.08601 1.60028 2.34315 2.34315C1.60028 3.08601 1.011 3.96793 0.608964 4.93853C0.206926 5.90914 0 6.94943 0 8C0 9.05058 0.206926 10.0909 0.608964 11.0615C1.011 12.0321 1.60028 12.914 2.34315 13.6569C3.08601 14.3997 3.96793 14.989 4.93853 15.391C5.90914 15.7931 6.94943 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 3.16163e-08 8 0ZM8 1.11628C7.80577 1.11628 7.55423 1.21005 7.26251 1.51219C6.96781 1.8173 6.67386 2.29433 6.4134 2.94474C6.15516 3.59144 5.94456 4.37135 5.80019 5.24353C5.68484 5.94307 5.61414 6.68502 5.59033 7.44186H10.4097C10.3882 6.70527 10.3181 5.97089 10.1998 5.24353C10.0554 4.37135 9.84484 3.59144 9.5866 2.94474C9.32614 2.29433 9.03219 1.8173 8.73823 1.51219C8.44577 1.21005 8.19498 1.11628 8 1.11628ZM11.5274 7.44186C11.5051 6.64388 11.4293 5.8483 11.3005 5.06047C11.1464 4.12726 10.9172 3.26698 10.6233 2.53023C10.4742 2.15074 10.2919 1.78517 10.0785 1.43777C11.1308 1.77059 12.0874 2.3518 12.8677 3.13228C14.0221 4.28699 14.7285 5.81444 14.8607 7.44186H11.5274ZM10.4097 8.55814H5.59033C5.6134 9.31498 5.68484 10.0569 5.80019 10.7565C5.94456 11.6287 6.15516 12.4086 6.4134 13.0553C6.67386 13.7057 6.96781 14.1827 7.26177 14.4878C7.55423 14.79 7.80502 14.8837 8 14.8837C8.19423 14.8837 8.44577 14.79 8.73749 14.4878C9.03219 14.1827 9.32614 13.7057 9.5866 13.0553C9.84484 12.4086 10.0554 11.6287 10.1998 10.7565C10.3152 10.0569 10.3859 9.31498 10.4097 8.55814ZM10.0793 14.5622C10.2802 14.2393 10.4625 13.8709 10.6225 13.4698C10.9172 12.733 11.1464 11.8727 11.3005 10.9395C11.429 10.1517 11.5046 9.3561 11.5267 8.55814H14.8607C14.7498 9.92065 14.2358 11.2193 13.3841 12.2886C12.5324 13.3579 11.3824 14.1494 10.0793 14.5622ZM5.92 14.5622C5.70711 14.2148 5.52532 13.8492 5.37674 13.4698C5.08205 12.733 4.85284 11.8727 4.69879 10.9395C4.57025 10.1517 4.49467 9.3561 4.47256 8.55814H1.1386C1.2494 9.92056 1.76331 11.2191 2.61483 12.2884C3.46636 13.3577 4.61696 14.1493 5.92 14.5622Z" fill="#424242"/>
      </svg>
      <input
        className={`large-compo-input fts-15 common-text ftw-4 ${errors.length > 0 ? 'input-error' : ''} ${type === 'date' ? 'input-box-with-icon' : ''}`}
        type={type}
        value={value}
        onChange={handleInputChange}
        placeholder=' '
        name={name}
      />
      <label className={`lt-gray url-label fts-13 ${value ? 'has-value' : ''}`}>{label}</label>
      {displayErrors.length > 0 && (
        <div className="input-error-message">
          {displayErrors[0]}
        </div>
      )}
    </div>
  );
};

export default LargeInputBoxWithIcon;